<template>
  <v-form v-model="valid">
    <slot></slot>
    <v-select
      name="type"
      label="Type"
      :items="contactDetailTypeOptions"
      :value="value.type"
      @input="onInput('type', $event)"
    />

    <vue-tel-input-vuetify
      v-if="value.type === ContactDetailType.PHONE || value.type === ContactDetailType.MOBILE || value.type === ContactDetailType.FAX"
      type="tel"
      defaultCountry="AU"
      mode="international"
      :label="contactDetailType"
      :name="contactDetailType"
      :onlyCountries="['AU']"
      :value="value.value"
      :rules="phoneNumberRules"
      @input="onInput('value', $event)"
    />
    <v-text-field
      v-else-if="value.type === ContactDetailType.WEBSITE"
      :name="contactDetailType"
      :label="contactDetailType"
      :value="value.value"
      :rules="urlRules"
      @input="onInput('value', $event)"
      required
    />
    <v-text-field
      v-else-if="value.type === ContactDetailType.EMAIL"
      type="email"
      :name="contactDetailType"
      :label="contactDetailType"
      :value="value.value"
      :rules="emailRules"
      @input="onInput('value', $event)"
      required
    />
    <v-text-field
      v-else
      :name="contactDetailType"
      :label="contactDetailType"
      :value="value.value"
      @input="onInput('value', $event)"
      required
    />

    <v-text-field
      name="note"
      label="Notes"
      :value="value.note"
      :counter="100"
      :rules="noteRules"
      @input="onInput('note', $event)"
    />
  </v-form>
</template>

<script>
import { set } from 'lodash'
import { ContactDetailType } from '@mymsa/common'
import isEmail from 'validator/es/lib/isEmail'
import isURL from 'validator/es/lib/isURL'
import {
  contactDetailTypeMap,
  contactDetailTypeOptions
} from '../../utilities/index.js'
import { validatePhoneNumber } from '../../validation/phone-number.js'

export default {
  name: 'ContactDetailsForm',

  data: () => ({
    valid: false,
    ContactDetailType,
    contactDetailTypeOptions,
    emailRules: [
      v => !!v || 'E-mail is required',
      v => (v && isEmail(v)) || 'E-mail must be a valid email address.'
    ],
    phoneNumberRules: [
      v => !!v || 'Phone number is required',
      v => (v && validatePhoneNumber(v)) || 'Phone number must be a valid phone number.'
    ],
    urlRules: [
      v => !!v || 'URL is required',
      v => (v && isURL(v)) || 'URL must be a valid URL.'
    ],
    noteRules: [
      v => (v && v.length <= 100) || 'Note must be less than 100 characters'
    ]
  }),

  props: {
    value: {
      type: Object,
      default: () => ({
        type: ContactDetailType.EMAIL,
        value: null,
        note: null
      })
    }
  },

  watch: {
    valid (valid) {
      this.$emit('valid', valid)
    }
  },

  computed: {
    contactDetailType () {
      return contactDetailTypeMap[this.value.type]
    }
  },

  methods: {
    onInput (key, value) {
      const o = { ...this.value }
      set(o, key, value)
      this.$emit('input', o)
    }
  }
}
</script>
